/**
 * Environment utility functions for controlling debug behavior and environment-specific features
 */

export const getEnvironment = (): string => {
  return process.env.REACT_APP_ENVIRONMENT || "development";
};

export const isDevelopment = (): boolean => {
  return getEnvironment() === "development";
};

export const isProduction = (): boolean => {
  return getEnvironment() === "production";
};

export const isStaging = (): boolean => {
  return getEnvironment() === "staging";
};

/**
 * Environment-specific configuration
 */
export const getEnvironmentConfig = () => {
  const env = getEnvironment();

  return {
    environment: env,
    isDevelopment: env === "development",
    isProduction: env === "production",
    isStaging: env === "staging",
    enableDebugLogging: env === "development" || env === "staging",
    enableVerboseLogging: env === "development",
    showDebugInfo: env === "development" || env === "staging",
    // Dialogflow configuration
    dialogflow: {
      projectId: process.env.REACT_APP_DIALOGFLOW_PROJECT_ID || "",
      accessToken: process.env.REACT_APP_DIALOGFLOW_ACCESS_TOKEN || "",
      enabled: process.env.REACT_APP_DIALOGFLOW_ENABLED === "true",
      fallbackEnabled:
        process.env.REACT_APP_DIALOGFLOW_FALLBACK_ENABLED !== "false",
    },
  };
};

/**
 * Get a human-readable environment name for display
 */
export const getEnvironmentDisplayName = (): string => {
  const env = getEnvironment();

  switch (env) {
    case "development":
      return "Development";
    case "staging":
      return "Staging";
    case "production":
      return "Production";
    default:
      return "Unknown";
  }
};
